import { Button } from '@ps/isp-web-component-library';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation, useResolver } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  TXTWCL_Visit_Help_Center,
  TXTWCL_WeXve_had_to_call_a_timeout_fo_ELL,
  TXTWCL_You_can_still_use_our_online_H_ELL_2
} from './Maintenance.messages.json';
import styles from './Maintenance.scss';
import Logo from './assets/logo-pokerstars-sports.svg';

export const MaintenanceText: React.FC = () => (
  <div>
    <h1 className={styles.title}>
      <Translation {...TXTWCL_WeXve_had_to_call_a_timeout_fo_ELL} />
    </h1>
  </div>
);

export const Maintenance: React.FC = () => {
  const isHelpCenterAvailable = useSelector(select.system.isCMSAvailable);
  const helpCenterUrl = useResolver(ResolverTag.HelpArticlesSportsMaintenance);

  return (
    <div className={styles.banner}>
      <div className={styles.sportsMaintenance}>
        <div className={styles.messageContainer}>
          <MaintenanceText />
          {isHelpCenterAvailable && (
            <div>
              <h2 className={styles.subTitle}>
                <Translation {...TXTWCL_You_can_still_use_our_online_H_ELL_2} />
              </h2>
              <Button size="medium" as="a" href={helpCenterUrl} rel="noreferrer">
                <Translation {...TXTWCL_Visit_Help_Center} />
              </Button>
            </div>
          )}
        </div>
        <Logo className={styles.logo} />
      </div>
    </div>
  );
};

export default Maintenance;
